// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vzBk","input":"styles_input__2b80k"};